interface IncrementalListFooterProps {
  label: string;
  loaded: number;
  total?: number;
  hasMore: boolean;
  loading?: boolean;
  error?: boolean;
  onLoadMore: () => void;
}

/** Progressive list affordance: no automatic scrolling, and an accessible loading state. */
export function IncrementalListFooter({ label, loaded, total, hasMore, loading = false, error = false, onLoadMore }: IncrementalListFooterProps) {
  if (!hasMore && !error) return null;
  return (
    <div className="r42-incremental-footer" aria-label={`${label} pagination`}>
      <span className="r42-incremental-footer__count" aria-live="polite">
        {total === undefined ? `${loaded} ${label} loaded` : `Showing ${loaded} of ${total} ${label}`}
      </span>
      {error ? <span role="alert">Could not load more {label}. Try again.</span> : null}
      <button
        type="button"
        className="btn btn-outline-secondary"
        disabled={loading}
        aria-busy={loading}
        onClick={onLoadMore}
      >
        {loading ? 'Loading…' : error ? 'Try loading more' : `Load more ${label}`}
      </button>
    </div>
  );
}
